import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import s from './ProgressModal.scss'

const ProgressModal = ({ loadingStep, isProgressModalVisible }) => {
  return (
    <>
      <Modal
        centered
        keyboard={false}
        backdrop="static"
        isOpen={isProgressModalVisible}
        size="md"
        className={s.modal}
      >
        <ModalHeader className={s.modalHeader}>Processing...</ModalHeader>
        <ModalBody className={s.modalBody}>
          <p style={{ textAlign: 'center' }}>{loadingStep}</p>
          <div className={s.progressGif} />
        </ModalBody>
      </Modal>
    </>
  )
}

export default ProgressModal
